// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1xqyg","text":"style_text__2Eo8x","squares":"style_squares__2s6WS","square":"style_square__3fETe","inner":"style_inner__2tmVu","inView":"style_inView___d_hH"};